import Router from "next/router";
import Script from "next/script";
import { useSession } from "next-auth/react";
import AboutUsAdminBackground from "@/admin/molecules/AboutUsAdminBackground";
import LoadingState from "@/sharedComponents/atoms/LoadingState";
import { tawkLink } from "src/services/connection";
import HomeHeader from "src/pages/seoComponent";

function AboutUs(): JSX.Element {
  const { status } = useSession();

  if (status === "authenticated") {
    Router.replace(
      {
        pathname: "/admin-portal/course-manager/all-courses",
      },
      "/admin-portal/course-manager/all-courses"
    );
  } else {
    return (
      <>
        <HomeHeader title="About Us" />
        <div className="w-full h-screen ">
          <Script strategy="lazyOnload" src={tawkLink} />
          <AboutUsAdminBackground />
        </div>
      </>
    );
  }
  return (
    <div className="flex place-content-center h-screen">
      <LoadingState />
    </div>
  );
}

export default AboutUs;
